module.exports = __webpack_public_path__ + "static/media/any.a7308859.png";